import React from 'react';
import logo from '../../assets/images/logo.svg';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Dashboard from '../../assets/images/dashboard/sideBar/dashboard.svg';
import ActiveDashboard from '../../assets/images/dashboard/sideBar/ActiveDashboard.svg'
import ActiveTasks from '../../assets/images/dashboard/sideBar/ActiveTasks.svg'
import ActiveRequest from '../../assets/images/dashboard/sideBar/ActiveRequests.svg'
import ActiveCoupons from '../../assets/images/dashboard/sideBar/ActiveCoupons.svg'
import Requests from '../../assets/images/dashboard/sideBar/request.svg';
import Message from '../../assets/images/dashboard/sideBar/tasks.svg';
import Coupons from '../../assets/images/dashboard/sideBar/coupons.svg';
import Settings from '../../assets/images/dashboard/sideBar/Setting.svg';
import Accounts from '../../assets/images/dashboard/sideBar/Profile.svg';
import Help from '../../assets/images/dashboard/sideBar/help.svg';

const DashboardSideBar = ({ setIsMobileMenuOpen }) => {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <div className='w-full flex flex-col justify-center items-center px-4 bg_header'>
            <div className='w-full flex justify-start'>
                <img
                    src={logo}
                    alt="Company logo"
                    className='w-8 my-2 cursor-pointer'
                    onClick={() => navigate('/')}
                />
            </div>

            <div className='w-full'>
                <p className='p-3 text-xs'>MENU</p>
                {(location.pathname.includes('/organization') || location.pathname.includes('/volunteer') || location.pathname.includes('/admin')) && (
                    <div>
                        {location.pathname.includes('/organization') && (
                            <>
                                <NavLink onClick={() => setIsMobileMenuOpen(false)} className="menu_button" to="/organization/dashboard">
                                    <img src={location.pathname.startsWith('/organization/dashboard') ? ActiveDashboard : Dashboard} alt="Dashboard" />
                                    <span>Dashboard</span>
                                </NavLink>

                                <NavLink onClick={() => setIsMobileMenuOpen(false)} className="menu_button" to="/organization/requests">
                                    <img src={location.pathname.startsWith('/organization/requests') ? ActiveRequest : Requests} alt="Requests" />
                                    <span>Requests</span>
                                </NavLink>

                                <NavLink onClick={() => setIsMobileMenuOpen(false)} className="menu_button" to="/organization/coupons">
                                    <img src={location.pathname.startsWith('/organization/coupons') ? ActiveCoupons : Coupons} alt="Coupons" />
                                    <span>Coupons</span>
                                </NavLink>
                            </>
                        )}

                        {location.pathname.startsWith('/admin') && (
                            <>
                                <NavLink onClick={() => setIsMobileMenuOpen(false)} className="menu_button" to="/admin/dashboard">
                                <img src={location.pathname.startsWith('/admin/dashboard') ? ActiveDashboard : Dashboard} alt="Dashboard" />
                                    <span>Dashboard</span>
                                </NavLink>

                                <NavLink onClick={() => setIsMobileMenuOpen(false)} className="menu_button" to="/admin/requests">
                                <img src={location.pathname.startsWith('/admin/requests') ? ActiveRequest : Requests} alt="Requests" />
                                    <span>Requests</span>
                                </NavLink>
                            </>
                        )}

                        {location.pathname.startsWith('/volunteer') && (
                            <>
                                <NavLink onClick={() => setIsMobileMenuOpen(false)} className="menu_button" to="/volunteer/dashboard">
                                    <img src={location.pathname.startsWith('/volunteer/dashboard') ? ActiveDashboard : Dashboard} alt="Dashboard" />
                                    <span>Dashboard</span>
                                </NavLink>

                                <NavLink onClick={() => setIsMobileMenuOpen(false)} className="menu_button" to="/volunteer/requests">
                                    <img src={location.pathname.startsWith('/volunteer/requests') ? ActiveRequest : Requests} alt="Requests" />
                                    <span>Requests</span>
                                </NavLink>

                                <NavLink onClick={() => setIsMobileMenuOpen(false)} className="menu_button" to="/volunteer/tasks">
                                    <img src={location.pathname.startsWith('/volunteer/tasks') ? ActiveTasks : Message} alt="Tasks" />
                                    <span>Tasks</span>
                                </NavLink>

                                <NavLink onClick={() => setIsMobileMenuOpen(false)} className="menu_button" to="/volunteer/coupons">
                                    <img src={location.pathname.startsWith('/volunteer/coupons') ? ActiveCoupons : Coupons} alt="Coupons" />
                                    <span>Coupons</span>
                                </NavLink>
                            </>
                        )}
                    </div>
                )}

                <p className='p-3 text-xs'>OTHERS</p>
                <span onClick={() => setIsMobileMenuOpen(false)} className="menu_button">
                    <img src={Settings} alt="Settings" />
                    <span>Settings</span>
                </span>

                <span onClick={() => setIsMobileMenuOpen(false)} className="menu_button">
                    <img src={Accounts} alt="Accounts" />
                    <span>Accounts</span>
                </span>

                <span onClick={() => setIsMobileMenuOpen(false)} className="menu_button">
                    <img src={Help} alt="Help" />
                    <span>Help</span>
                </span>
            </div>
        </div>
    );
};

export default DashboardSideBar;
